export default {
  CONFIGURATION_VERIFICATION_SMAIL_PASSPORT: {// 完成
    key: 'configuration_verification_smail_passport',
    label: '配置管理-月结验证方式-寄付月结-【设置月结支付密码】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PHONE: {// 完成
    key: 'configuration_verification_receipt_phone',
    label: '配置管理-月结验证方式-到付月结-【设置手机号白名单】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PASSPORT: {// 完成
    key: 'configuration_verification_receipt_passport',
    label: '配置管理-月结验证方式-到付月结-【设置月结支付密码】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PHONE_ENABLE: {// 完成
    key: 'configuration_verification_receipt_phone_enable',
    label: '配置管理-月结验证方式-到付月结-设置手机号白名单-【停用/启用】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PHONE_MODIFY: {// 完成
    key: 'configuration_verification_receipt_phone_modify',
    label: '配置管理-月结验证方式-到付月结-设置手机号白名单-【修改/删除】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PHONE_CONFIRM: {// 完成
    key: 'configuration_verification_receipt_phone_confirm',
    label: '配置管理-月结验证方式-到付月结-设置手机号白名单-【确认】'
  },
  CONFIGURATION_VERIFICATION_RECEIPT_PHONE_CANCEL: {// 完成
    key: 'configuration_verification_receipt_phone_cancel',
    label: '配置管理-月结验证方式-到付月结-设置手机号白名单-【取消】'
  }

}
